import { HttpResponse } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CampaniaEspecificaItemResultsViewModel, FilterSearchingTCampaniaEspecificaViewModel, TCampaniaEspecificaViewModel } from './campaniaespecifica.types';

@Injectable()
export class CampaniaEspecificaService {
    private endpoint = this.baseUrl + 'api/mantenimiento/campaniaespecifica/';
    private lastSearch?: FilterSearchingTCampaniaEspecificaViewModel;
    private _campaniaEspecifica: TCampaniaEspecificaViewModel;

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    /**
     * Creates an HttpParms object through the values in the parameter.
     * @param payload FilterSearchingTCampaniaEspecificaViewModel
     * @returns HttpParams
     */
    private convertModelToHttpParms(payload: FilterSearchingTCampaniaEspecificaViewModel): HttpParams {
        let params = new HttpParams();
        let k: keyof FilterSearchingTCampaniaEspecificaViewModel;

        for (k in payload) {
            const v = payload[k] || '';
            params = params.append(k, v);
        }

        return params;
    }

    /**
     * Invokes the service to get the list of "Campañas Específicas", applying the filter in the parameter
     * @param payload FilterSearchingTCampaniaEspecificaViewModel
     * @returns Observable<CampaniaEspecificaItemResultsViewModel>
     */
    getList(payload: FilterSearchingTCampaniaEspecificaViewModel): Observable<CampaniaEspecificaItemResultsViewModel> {
        this.lastSearch = payload; // Keep for future search
        const params = this.convertModelToHttpParms(payload);
        return this.getPagedByFilter(params);
    }

    /**
     * Invokes the service to get the list of "Campañas Específicas", applying the filter in the parameter
     * @param params HttpParams
     * @returns Observable<CampaniaEspecificaItemResultsViewModel>
     */
    private getPagedByFilter(params: HttpParams): Observable<CampaniaEspecificaItemResultsViewModel> {
        return this.http.get<CampaniaEspecificaItemResultsViewModel>(this.endpoint + 'PagedByFilter/', { params: params });
    }

    getById(id: number): Observable<TCampaniaEspecificaViewModel> {
        return this.http.get<TCampaniaEspecificaViewModel>(this.endpoint + id);
    }

    set campaniaEspecifica(campaniaEspecifica: TCampaniaEspecificaViewModel) {
        this._campaniaEspecifica = campaniaEspecifica;
    }

    get campaniaEspecifica(): TCampaniaEspecificaViewModel {
        return this._campaniaEspecifica;
    }

    save(payload: TCampaniaEspecificaViewModel): Observable<any> {
        // delete model.Descripcion;  // Para forzar un fallo en el backend y ver que pasa en el catchError
        if (payload?.Id) {
            return this.edit(payload);
        }
        return this.create(payload);
    }

    private create(payload: TCampaniaEspecificaViewModel): Observable<any> {
        // payload.Id = 1; // Para forzar un fallo en el backend y ver que pasa en el catchError
        delete payload.Id;
        delete payload.FechaCreacion;
        return this.http.post<TCampaniaEspecificaViewModel>(this.endpoint, payload);
    }

    private edit(payload: TCampaniaEspecificaViewModel): Observable<any> {
        // payload.Id = null; // Para forzar un fallo en el backend y ver que pasa en el catchError
        return this.http.put<TCampaniaEspecificaViewModel>(this.endpoint, payload);
    }

    export(model: FilterSearchingTCampaniaEspecificaViewModel): Observable<HttpResponse<Blob>> {
        return this.http.post(this.endpoint + 'postExportExcelByFilter', model, { observe: 'response', responseType: 'blob' });
    }

    getLastSearch(): FilterSearchingTCampaniaEspecificaViewModel | undefined {
        return this.lastSearch;
    }

    clearLastSearch(): void {
        this.lastSearch = undefined;
    }

    // Documentación Campañas

    saveDocumentation(campania: TCampaniaEspecificaViewModel): Observable<any> {
        return this.editDocumentation(campania);
    }

    private editDocumentation(campania: TCampaniaEspecificaViewModel): Observable<any> {
        return this.http.put<TCampaniaEspecificaViewModel>(this.endpoint + 'Documentacion/', campania);
    }
}
